// Portal texts (pt-BR). Copy follows the Aubaine design system voice: sentence case, "você",
// labels say what happens, errors say how to fix, no exclamation marks.
export default {
  app: {
    title: 'Portal do assistente',
    loading: 'Carregando',
    close: 'Fechar',
    closeNotification: 'Fechar notificação',
    cancel: 'Cancelar',
    back: 'Voltar',
    continue: 'Continuar',
    save: 'Salvar alterações',
    discard: 'Descartar',
    retry: 'Tentar novamente',
    copy: 'Copiar',
    copied: 'Copiado',
    you: '(você)',
    unknown: '-',
    platformAdmin: 'Administrador da plataforma',
    erpConnected: 'ERP conectado',
  },
  // Second part of the browser tab title ("{institution} - {screen}"), by route name.
  pageTitles: {
    chat: 'Chat',
    conversations: 'Conversas',
    users: 'Usuários e Permissões',
    'user-detail': 'Usuário',
    'role-edit': 'Papel',
    audit: 'Auditoria',
    settings: 'Configurações',
    'tenant-picker': 'Escolha a empresa',
    'erp-dashboard': 'Painel',
    'erp-crm': 'CRM',
    'erp-customers': 'Clientes',
    'erp-customer': 'Cliente',
    'erp-activities': 'Atividades',
    'erp-history': 'Histórico',
    'erp-projects': 'Projetos',
    'erp-project-new': 'Novo projeto',
    'erp-project': 'Projeto',
    'erp-project-edit': 'Editar projeto',
    'erp-customer-report': 'Relatório do cliente',
    'erp-diagnosis': 'Diagnóstico',
    'erp-granola': 'Gravações',
    'erp-tasks': 'Tarefas',
    'erp-task-new': 'Nova tarefa',
    'erp-task': 'Tarefa',
    'erp-task-edit': 'Editar tarefa',
    'erp-calendar': 'Agenda',
    'erp-meetings': 'Reuniões',
    'erp-finance': 'Financeiro',
    'erp-accounts': 'Contas financeiras',
    'erp-financial-categories': 'Categorias financeiras',
    'erp-classification-rules': 'Regras de classificação',
    'erp-suppliers': 'Fornecedores',
    'erp-activity-types': 'Tipos de atividade',
    'erp-project-templates': 'Modelos de projeto',
    'erp-project-file-types': 'Tipos de arquivo',
    'erp-automations': 'Automações comerciais',
    'erp-employees': 'Funcionários',
    'erp-catalog': 'Catálogo',
    'erp-proposals': 'Propostas',
    'erp-proposal': 'Proposta',
    'erp-proposal-new': 'Nova proposta',
    'erp-tickets': 'Chamados',
    'erp-ticket': 'Chamado',
    'erp-tickets-all': 'Chamados das instituições',
    'erp-support': 'Suporte',
    'erp-support-ticket': 'Chamado de suporte',
    'erp-wiki': 'Wiki',
    'erp-projects-report': 'Projetos e tarefas',
    'erp-finance-monthly': 'Receitas e despesas mensais',
    'erp-commissions-report': 'Comissões a fechar',
    'erp-integrations': 'Integrações',
    'monitoring-alerts': 'Monitoramento',
    'campaign-results': 'Resultados dos envios',
    'campaign-flows': 'Campanhas',
    'campaign-flow-new': 'Nova campanha',
    'campaign-flow': 'Campanha',
    'campaign-flow-edit': 'Editar campanha',
    'campaign-templates': 'Conteúdos',
    'campaign-template-new': 'Novo conteúdo',
    'campaign-template': 'Conteúdo',
    'campaign-contacts': 'Contatos',
    'campaign-optouts': 'Descadastros',
    'campaign-contact': 'Contato',
    'campaign-exports': 'Exportações',
    'campaign-settings': 'Configurações de campanhas',
    'monitoring-alert-new': 'Novo alerta',
    'monitoring-alert': 'Alerta',
    'monitoring-alert-edit': 'Editar alerta',
    'monitoring-run': 'Resultado do alerta',
    'cnpj-home': 'Análise de CNPJ',
  },
  nav: {
    profile: 'Meu perfil',
    ai: 'IA',
    chat: 'Chat',
    conversations: 'Conversas',
    users: 'Usuários e Permissões',
    audit: 'Auditoria',
    settings: 'Configurações',
    integrations: 'Integrações',
    switchTenant: 'Trocar de empresa',
  },
  tenantPicker: {
    title: 'Escolha a empresa',
    subtitle: 'Você entrou como {email}.',
    subtitleNoEmail: 'Você tem acesso a mais de uma empresa neste portal.',
    empty: 'Nenhuma empresa disponível',
    emptyHint: 'Esta conta ainda não tem acesso ao assistente de nenhuma empresa. Peça um convite ao responsável da sua empresa.',
    otherAccount: 'Entrar com outra conta',
    adminOnly: 'Só quem administra a empresa abre o portal por enquanto',
    brandName: 'Assistente IA',
    consoleLabel: 'Console da plataforma',
    protectedBy: 'Protegido pela Aubaine',
    notRegistered: 'Ainda não cadastrada no assistente',
    searchAll: 'Buscar entre todas as instituições',
    searchPlaceholder: 'Nome ou identificador',
    platformAdmin: 'Como administrador da plataforma, você pode abrir qualquer instituição.',
    open: 'Abrir',
  },
  conversations: {
    title: 'Conversas',
    subtitleAll: 'As conversas das pessoas da {tenant} com o assistente, no WhatsApp e no portal.',
    subtitleOwn: 'As suas conversas com o assistente, no WhatsApp e no portal.',
    search: 'Buscar',
    searchPlaceholder: 'Assunto ou texto da conversa',
    channel: 'Canal',
    person: 'Pessoa',
    all: 'Todos',
    everyone: 'Todas as pessoas',
    channels: { whatsapp: 'WhatsApp', portal: 'Portal', teams: 'Teams' },
    count: 'Nenhuma conversa | 1 conversa | {count} conversas',
    messages: 'Nenhuma mensagem | 1 mensagem | {count} mensagens',
    emptyTitle: 'Nenhuma conversa ainda',
    emptyTextAll: 'Quando alguém falar com o assistente pelo WhatsApp ou pelo portal, a conversa aparece aqui.',
    emptyTextOwn: 'Quando você falar com o assistente pelo WhatsApp ou pelo portal, a conversa aparece aqui.',
    noMatch: 'Nenhuma conversa com esses filtros.',
    clearFilters: 'Limpar filtros',
    loadMore: 'Carregar mais',
    pick: 'Escolha uma conversa para ler.',
    back: 'Voltar para a lista',
    continue: 'Continuar no chat',
    privacy: 'Você está vendo a conversa de outra pessoa. Esta leitura fica registrada na auditoria.',
    assistant: 'Assistente',
    errorTitle: 'Não foi possível carregar as conversas',
    queries: 'Consultas: {queries}',
    // Only for the owner and for roles with "Controle uso IA": the server leaves it out for anyone else.
    usage: {
      title: 'Custo estimado',
      tokens: '{count} tokens',
      answers: 'Nenhuma resposta | 1 resposta | {count} respostas',
      transcription: 'Transcrição de áudio: {cost}',
      hint: 'Valor de referência, estimado a partir do uso de IA desta conversa.',
    },
    tabs: { label: 'Conversas', conversations: 'Conversas', unidentified: 'Não identificados' },
    unidentified: {
      intro: 'Números que escreveram no WhatsApp da empresa sem um acesso ativo. Convide quem deve usar o assistente; os registros somem em 30 dias.',
      empty: 'Nenhuma mensagem de número desconhecido.',
      reasons: {
        unknown_contact: 'Número sem acesso',
        revoked: 'Acesso revogado',
        invalid_code: 'Código de convite inválido',
      },
      messages: '1 mensagem | {count} mensagens',
      last: 'Última: {when}',
      invite: 'Convidar',
      dismiss: 'Dispensar',
      dismissed: 'Contato dispensado',
    },
  },
  chat: {
    title: 'Chat',
    newChat: 'Nova conversa',
    recent: 'Recentes',
    noConversations: 'Suas conversas aparecem aqui.',
    conversations: 'Conversas',
    openList: 'Ver conversas',
    closeList: 'Fechar conversas',
    greeting: 'Olá, {name}!',
    intro: 'Sou {assistant}, o assistente da {tenant}. Pergunte sobre {topics}. Respondo só com o que o seu papel permite e, quando liberado, preparo cadastros para você revisar e confirmar.',
    introNone: 'Sou {assistant}, o assistente da {tenant}. O seu papel ainda não tem consultas liberadas: fale com o administrador.',
    scopeUnits: 'Você vê os dados de: {units}.',
    scopePartition: 'Você vê os dados de {count} {plural}.',
    suggestions: {
      consultar_estoque: 'Quais produtos estão abaixo do estoque mínimo?',
      consultar_pedidos: 'Quais pedidos estão em aberto?',
      consultar_inadimplencia: 'Quem está com títulos vencidos há mais de 30 dias?',
      consultar_fluxo_caixa: 'Como fica o caixa nas próximas 4 semanas?',
    },
    inputLabel: 'Mensagem para o assistente',
    placeholder: 'Pergunte algo ao {assistant}…',
    send: 'Enviar mensagem',
    thinking: 'Consultando o {erp}…',
    thinkingNoErp: 'Pensando…',
    disclaimer: 'O assistente responde com os dados do ERP que o seu papel permite. Confira informações importantes antes de decidir.',
    unavailableTitle: 'O assistente ainda não está disponível',
    unavailableText: 'A integração com a IA ainda não foi configurada. Você pode escrever, mas a resposta vai avisar que o assistente não está ativo.',
    noAccessTitle: 'Você não tem acesso ao assistente desta empresa',
    noAccessText: 'O chat é para quem foi convidado para a empresa. Administradores da plataforma sem convite não conversam com o assistente.',
    errorTitle: 'Não foi possível carregar o chat',
    copy: 'Copiar',
    copyHint: 'Copia a resposta formatada (e-mail, Word, Teams) e como texto (WhatsApp)',
    copied: 'Resposta copiada',
    copiedHint: 'Cole no e-mail, no Teams ou no WhatsApp.',
    source: 'Fonte: {erp} · {queries}',
    blockedTitle: 'Consulta bloqueada',
    blockedText: 'Parte do que você pediu está fora do seu papel ou da sua unidade. A tentativa foi registrada na auditoria.',
    unsupportedTitle: 'Informação indisponível',
    unsupportedText: 'O sistema da empresa não oferece essa informação.',
    topicTitle: 'Fora do que o assistente faz',
    topicText: 'Esse pedido está fora do escopo do assistente. A tentativa foi registrada na auditoria.',
    hiddenTitle: 'Campo oculto',
    hiddenText: 'Alguns campos não são exibidos para o seu papel.',
    sendFailed: 'Não foi possível enviar a pergunta',
    stop: 'Parar',
    stopped: 'Resposta interrompida.',
    querying: 'Consultando {query} no {erp}…',
    actions: {
      reviewTitle: 'Ação aguardando sua confirmação',
      expires: 'Expira às {date}.',
      confirm: 'Confirmar cadastro',
      reject: 'Rejeitar',
      completedTitle: 'Empresa cadastrada',
      completedText: 'O cadastro foi concluído no CRM.',
      failedTitle: 'Não foi possível concluir o cadastro',
      failedText: 'A ação falhou. Confira o estado antes de tentar novamente.',
      confirmFailed: 'Não foi possível confirmar a ação',
      rejectFailed: 'Não foi possível rejeitar a ação',
      rejectedTitle: 'Ação rejeitada',
      loadFailed: 'Não foi possível carregar as ações pendentes.',
    },
    viewAs: 'Ver como',
    viewAsMe: 'Eu mesmo',
    viewAsNote: 'Você está vendo como {name} ({role}): as respostas seguem as permissões dessa pessoa e não são salvas.',
    activity: {
      button: 'Atividade',
      toggle: 'Mostrar ou esconder o que a IA está fazendo',
      title: 'O que a IA está fazendo',
      close: 'Fechar',
      show: 'Atividade',
      follow: 'Acompanhar',
      hint: 'Os passos de cada resposta: as consultas feitas, com os filtros usados e o resultado. Os dados em si ficam só na resposta.',
      empty: 'Faça uma pergunta para acompanhar aqui cada passo da resposta.',
      history: 'O passo a passo fica disponível só para as respostas desta sessão.',
      historyQueries: 'Consultas usadas: {queries}.',
      understanding: 'Entendendo a pergunta',
      understood: 'Pergunta entendida',
      querying: 'Consultando {query} no {erp}',
      queried: 'Consultou {query}',
      writing: 'Escrevendo a resposta',
      written: 'Resposta escrita',
      done: 'Concluída',
      rows: 'Nenhum registro encontrado | 1 registro encontrado | {n} registros encontrados',
      partial: 'Concluída sem os campos que o seu papel não vê',
      blocked: 'Bloqueada: {reason}',
      failed: 'Não deu certo: {reason}',
      stopped: 'Interrompida',
      seconds: '{seconds} s',
      queries: 'nenhuma consulta | 1 consulta | {n} consultas',
      summary: 'Concluída em {seconds} s, com {queries}.',
      summaryStopped: 'Interrompida depois de {seconds} s.',
      summaryFailed: 'Não foi possível concluir ({seconds} s).',
      reasons: {
        not_in_role: 'não incluída no seu papel',
        out_of_scope: 'fora das unidades do seu acesso',
        no_units: 'o seu papel precisa de unidades ou clientes definidos',
        out_of_topic: 'fora do que o assistente atende',
        invalid_arguments: 'os filtros não foram aceitos',
        erp_unavailable: 'o sistema da empresa não respondeu',
        unknown: 'erro inesperado',
      },
    },
    registration: {
      button: 'Registro',
      toggle: 'Mostrar ou esconder o registro no sistema',
      title: 'Registro no sistema',
      subtitle: 'Preenchido automaticamente a partir da conversa',
      close: 'Ocultar formulário',
      kinds: { customer: 'Novo cliente', contact: 'Novo contato' },
      progress: '{done} de {total} campos',
      states: {
        collecting: 'Em andamento',
        awaitingConfirmation: 'Aguardando confirmação',
        completed: 'Concluído',
      },
      waiting: 'Aguardando resposta',
      asking: 'Perguntando',
      skipped: 'Sem informação',
      invalid: 'Corrigir',
      source: { receita: 'Receita Federal', cep: 'CEP' },
      edit: 'Editar',
      editPrompt: 'Quero alterar {field}: ',
      editHint: 'Clicar em Editar devolve a pergunta para o chat: a conversa continua sendo o caminho principal.',
      confirm: 'Confirmar cadastro',
      confirmed: 'Cadastro concluído.',
      confirmFailed: 'Não foi possível concluir o cadastro',
      cancel: 'Cancelar cadastro',
      cancelled: 'Cadastro cancelado.',
      cancelFailed: 'Não foi possível cancelar o cadastro',
      openCustomer: 'Abrir o cliente',
      addContact: 'Cadastrar um contato',
      addContactPrompt: 'Quero cadastrar um contato nesse cliente.',
      newCustomer: 'Cadastrar outro cliente',
      newCustomerPrompt: 'Quero cadastrar outro cliente.',
      changes: 'Nenhuma alteração ainda | 1 alteração | {n} alterações',
      was: 'Antes: {value}',
      confirmEdit: 'Confirmar alterações',
      cancelEdit: 'Descartar alterações',
      editAnother: 'Fazer outra alteração',
      confirmedEdit: 'Cliente atualizado.',
      cancelRequest: 'Cancelar pedido',
      dismiss: 'Fechar',
      expires: 'O plano expira em poucos minutos: confirme aqui ou responda "sim" no chat.',
    },
    export: {
      title: 'Exportar',
      you: 'Você',
      copyConversation: 'Copiar conversa',
      copyConversationHint: 'Formatada para e-mail, Word ou Teams',
      downloadText: 'Baixar como texto (.txt)',
      downloadTextHint: 'Para guardar ou anexar',
      print: 'Imprimir ou salvar em PDF',
      printHint: 'Só a conversa, sem o resto do portal',
      conversationCopied: 'Conversa copiada',
      copyTable: 'Copiar tabela',
      downloadCsv: 'Baixar CSV',
      tableCopied: 'Tabela copiada: cole numa planilha ou num e-mail.',
      copyFailed: 'Não foi possível copiar. O navegador bloqueou a área de transferência.',
    },
  },
  users: {
    title: 'Usuários e Permissões',
    subtitle: 'Quem pode consultar o assistente e quais dados cada pessoa vê.',
    invite: 'Convidar usuário',
    tabs: { label: 'Seções', users: 'Usuários', roles: 'Papéis' },
    search: 'Buscar',
    searchPlaceholder: 'Nome, número, conta Teams ou e-mail',
    filters: 'Filtros',
    hideFilters: 'Ocultar filtros',
    appliedFilters: 'Filtros aplicados:',
    removeFilter: 'Remover filtro {name}',
    clearFilters: 'Limpar filtros',
    resultCount: '{filtered} de {total} usuários',
    all: 'Todos',
    allUnits: 'Todas',
    columns: {
      name: 'Nome',
      channels: 'Canais',
      phone: 'Celular',
      contact: 'E-mail / Teams',
      role: 'Papel',
      units: 'Unidades',
      status: 'Status',
      lastAccess: 'Último acesso',
      actions: 'Ações',
    },
    filter: { role: 'Papel', channel: 'Canal', status: 'Status', unit: 'Unidade' },
    loading: 'Carregando usuários',
    errorTitle: 'Não foi possível carregar os usuários',
    errorText: 'A conexão com o serviço de identidade falhou. Nenhuma permissão foi alterada.',
    emptyTitle: 'Nenhum usuário convidado.',
    emptyText: 'Convide gerentes e vendedores para consultar o assistente pelo WhatsApp, Teams ou portal.',
    noMatch: 'Nenhum usuário encontrado com esses filtros.',
    allUnitsLabel: 'Todas as unidades',
    rowMenu: 'Ações para {name}',
    actions: {
      details: 'Ver detalhes',
      changeRole: 'Editar papel',
      resend: 'Reenviar convite',
      copyActivationLink: 'Copiar link de ativação',
      revoke: 'Revogar acesso',
      delete: 'Excluir usuário',
    },
    moreContacts: '+{count}',
  },
  status: {
    pending: 'Pendente',
    active: 'Ativo',
    revoked: 'Revogado',
  },
  channels: {
    whatsApp: 'WhatsApp',
    teams: 'Teams',
    portal: 'Portal',
    whatsAppDesc: 'Perguntas pelo WhatsApp da empresa',
    teamsDesc: 'Conversa no Microsoft Teams',
    portalDesc: 'Chat no portal web',
  },
  whatsAppMode: {
    shared: 'Compartilhado',
    dedicated: 'Dedicado',
    sharedDesc: 'Número fixo da plataforma, com o assistente e o tom de voz padrão. Cada pessoa envia um código de convite uma vez para vincular o número.',
    dedicatedDesc: 'O número da própria empresa, conectado pela API oficial do WhatsApp, pela Z-API, pela Wafly ou pelo WPPConnect (não oficial), com nome, foto e tom de voz escolhidos pela empresa.',
  },
  capabilities: {
    consultar_estoque: 'Estoque',
    consultar_pedidos: 'Pedidos',
    consultar_inadimplencia: 'Inadimplência',
    consultar_fluxo_caixa: 'Fluxo de caixa',
    desc: {
      consultar_estoque: 'Saldos e disponibilidade de produtos',
      consultar_pedidos: 'Status, prazos e histórico de pedidos',
      consultar_inadimplencia: 'Títulos vencidos e clientes em atraso',
      consultar_fluxo_caixa: 'Entradas, saídas e saldo projetado',
    },
    reason: {
      not_in_role: 'Não incluído neste papel.',
      erp_unsupported: 'Indisponível: o ERP não disponibiliza essa informação.',
      erp_unsupported_named: 'Indisponível: o ERP {erp} não disponibiliza essa informação.',
    },
  },
  hiddenFields: {
    margem_lucro: 'Margem de lucro',
    custo_fornecedor: 'Custo do fornecedor',
  },
  // Administrative permissions of a role (not ERP queries).
  adminPermissions: {
    controle_uso_ia: 'Controle uso IA',
    permitir_realizar_acoes: 'Permitir realizar ações',
    desc: {
      controle_uso_ia: 'Vê o custo estimado e os tokens de cada conversa, em Conversas.',
      permitir_realizar_acoes: 'Pode solicitar ações no sistema; cada ação ainda exige permissão no ERP e confirmação.',
    },
  },
  roles: {
    readOnly: 'Somente leitura',
    usersWithRole: 'nenhum usuário | 1 usuário | {count} usuários',
    scopeAll: 'Todos os dados da empresa',
    scopeUnit: 'Somente das unidades do usuário',
    scopePartition: 'Somente dos {plural} da pessoa',
    hiddenNone: 'Nenhum campo oculto.',
    hiddenList: 'Oculta: {fields}',
    details: 'Ver detalhes',
    edit: 'Editar papel',
    view: 'Ver papel',
  },
  roleEdit: {
    locked: 'O papel Dono tem acesso total aos dados da empresa e não pode ser editado.',
    queries: 'Consultas liberadas',
    erp: 'ERP',
    erpHint: 'O que este papel pode fazer em cada área do ERP da empresa. Editar inclui ver.',
    erpGeneral: 'Geral',
    consult: 'Consultar {name}',
    scope: 'Escopo de dados',
    scopes: {
      all: 'Todos os dados da empresa',
      allDesc: 'Vê as informações de todas as unidades.',
      unit: 'Somente a unidade do usuário',
      unitDesc: 'Vê apenas as unidades definidas no convite de cada pessoa.',
      partition: 'Somente os {plural} da pessoa',
      partitionDesc: 'Vê apenas os {plural} definidos no cadastro de cada pessoa.',
      allConnectorDesc: 'Vê as informações de todos os {plural}.',
    },
    hidden: 'Campos ocultos',
    hiddenHint: 'Os campos marcados não serão exibidos para quem tiver este papel, em nenhuma consulta.',
    admin: 'Permissões administrativas',
    adminHint: 'Liberam telas e dados de gestão da empresa, além das consultas ao ERP.',
    impact: 'Nenhum usuário tem este papel hoje. | Esta alteração afeta 1 usuário. | Esta alteração afeta {count} usuários.',
    noChanges: 'Nenhuma alteração',
    changes: {
      addedQueries: 'Passa a consultar: {items}',
      erp: 'ERP: {items}',
      erpNone: 'sem acesso ao ERP',
      removedQueries: 'Deixa de consultar: {items}',
      scope: 'Escopo: {scope}',
      scopes: { all: 'todos os dados da empresa', unit: 'somente das unidades do usuário', partition: 'somente dos {plural} da pessoa' },
      hiddenAdded: 'Passa a ocultar: {items}',
      hiddenRemoved: 'Deixa de ocultar: {items}',
      adminAdded: 'Passa a ter: {items}',
      adminRemoved: 'Deixa de ter: {items}',
    },
    previewSub: 'O que quem tem este papel verá.',
    confirmTitle: 'Salvar alterações em {name}?',
    confirmText: 'Esta alteração afeta 1 usuário: {names}. As novas regras valem a partir da próxima consulta. | Esta alteração afeta {count} usuários: {names}. As novas regras valem a partir da próxima consulta de cada um.',
    confirmNobody: 'Ninguém tem este papel agora. As regras valem para os próximos convites.',
    confirm: 'Salvar alterações',
    savedToast: 'Papel atualizado',
    savedText: 'As novas regras de {name} já estão em vigor.',
    errors: {
      capabilities: 'Libere pelo menos uma consulta.',
    },
  },
  detail: {
    breadcrumb: 'Trilha',
    changeRole: 'Alterar papel/unidade',
    pending: 'Convite pendente. {name} ainda não fez o primeiro acesso.',
    revoked: 'Acesso revogado. As permissões abaixo não estão mais em vigor.',
    permissions: 'Permissões efetivas',
    permissionsSub: 'Definidas pelo papel {role}.',
    activity: 'Atividade recente',
    noActivity: 'Nenhuma alteração de acesso registrada ainda.',
    questionsSoon: 'As perguntas feitas ao assistente aparecem aqui quando o chat estiver ativo.',
  },
  notifications: {
    title: 'Alertas',
    open: 'Alertas',
    openUnread: 'Alertas, 1 não lido | Alertas, {count} não lidos',
    markAll: 'Marcar todos como lidos',
    seeAudit: 'Ver auditoria completa',
    all: 'Todos',
    unread: 'Não lidos',
    unreadMark: 'Não lido',
    none: 'Nenhum alerta.',
    noneUnread: 'Nenhum alerta não lido.',
    error: 'Não foi possível carregar as notificações.',
  },
  audit: {
    title: 'Auditoria',
    subtitle: 'Registro das consultas feitas ao assistente e das alterações de acesso.',
    export: 'Exportar CSV',
    tabs: { label: 'Registros', queries: 'Consultas', changes: 'Alterações de acesso' },
    exported: 'Exportação concluída',
    exportedText: 'Nenhum registro exportado. | 1 registro exportado em CSV. | {count} registros exportados em CSV.',
    queriesEmptyTitle: 'Nenhuma consulta registrada ainda',
    queriesEmptyText: 'Cada pergunta feita ao assistente, com o resultado (permitida, bloqueada ou com campo oculto), aparece aqui.',
    queries: {
      search: 'Buscar',
      searchPlaceholder: 'Pergunta ou usuário',
      filters: 'Filtros',
      hideFilters: 'Ocultar filtros',
      appliedFilters: 'Filtros aplicados:',
      removeFilter: 'Remover filtro {name}',
      clearFilters: 'Limpar filtros',
      result: 'Resultado',
      channel: 'Canal',
      capability: 'Consulta',
      period: 'Período',
      all: 'Todos',
      allFem: 'Todas',
      outOfScope: 'Fora do escopo',
      results: { ok: 'Permitida', blocked: 'Bloqueada', partial: 'Campo oculto', failed: 'Falhou' },
      channels: { whatsapp: 'WhatsApp', teams: 'Teams', portal: 'Portal', mcp: 'MCP' },
      periods: { today: 'Hoje', week: 'Últimos 7 dias', month: 'Últimos 30 dias', all: 'Todo o período' },
      count: 'Nenhum registro | 1 registro | {count} registros',
      blocked: '1 bloqueado | {count} bloqueados',
      noMatch: 'Nenhum registro encontrado com esses filtros.',
      truncated: 'Mostrando os registros mais recentes; use o período para ver os antigos.',
      tableLabel: 'Consultas ao ERP',
      columns: { when: 'Data/hora', user: 'Usuário', channel: 'Canal', question: 'Pergunta', capability: 'Consulta', result: 'Resultado' },
      csv: { when: 'Data/hora', user: 'Usuário', channel: 'Canal', question: 'Pergunta', capability: 'Consulta', result: 'Resultado', detail: 'Detalhe' },
    },
    changesEmpty: 'Nenhuma alteração registrada ainda.',
    unavailable: 'Não foi possível consultar a auditoria agora. Tente de novo em alguns minutos.',
    loadMore: 'Carregar mais',
    count: '{shown} de {total} registros',
    by: 'por {actor}',
    system: 'Sistema',
    unknownActor: 'Não identificado',
    csv: { when: 'Data/hora', actor: 'Quem', action: 'Ação', detail: 'Detalhe', fields: 'Campos' },
    fields: {
      show: 'Ver campo | Ver campo | Ver os {count} campos',
      hide: 'Ocultar campos',
      onlyChanges: 'Mostrar somente divergências',
      field: 'Campo',
      before: 'Antes',
      after: 'Depois',
      value: 'Valor',
      removed: 'Valor anterior',
      empty: '—',
    },
  },
  preview: {
    title: 'Prévia das permissões',
    subtitleRole: 'O que {name} poderá ver como {role}.',
    subtitleEmpty: 'Atualiza conforme você define o papel.',
    empty: 'Escolha um papel para ver o que a pessoa poderá consultar.',
    loading: 'Calculando permissões',
    error: 'Não foi possível calcular a prévia.',
    can: 'Pode consultar',
    cannot: 'Não pode consultar',
    nothing: 'Nenhuma consulta liberada.',
    scope: 'Dados',
    scopeAll: 'Todos os dados da empresa',
    scopeUnits: 'Somente dados de: {units}',
    scopeUnitsEmpty: 'Somente dados das unidades do usuário',
    scopeAllPartition: 'Todos os {plural}',
    scopePartition: 'Somente {plural}: {items}',
    scopePartitionEmpty: 'Somente os {plural} definidos para a pessoa',
    hidden: 'Campos ocultos',
    hiddenNone: 'Nenhum campo oculto.',
    hiddenFor: 'Oculto para {who}: {fields}.',
    thisUser: 'este usuário',
    roleHolders: 'quem tem este papel',
  },
  invite: {
    showQr: 'Mostrar QR code',
    hideQr: 'Ocultar QR code',
    qrLabel: 'QR code do link de convite do WhatsApp',
    qrHelp: '{name} pode apontar a câmera do celular para este código e enviar a mensagem que aparece.',
    sendByEmail: 'Enviar por e-mail',
    mailTo: 'E-mail do destinatário',
    mailToPlaceholder: "nome{'@'}empresa.com.br",
    mailHint: 'Abre o seu aplicativo de e-mail com a mensagem pronta.',
    mailOpen: 'Abrir e-mail',
    mailInvalid: 'Informe um e-mail válido.',
    mailSubject: 'Seu acesso ao assistente da {tenant}',
    mailBody: 'Olá, {name}.\n\nPara começar a usar o assistente pelo WhatsApp, abra o link abaixo e envie a mensagem que aparece:\n{link}',
    title: 'Convidar usuário',
    doneTitle: 'Convite criado',
    step: 'Etapa {step} de 3 · {name}',
    steps: { s1: 'Pessoa e canais', s2: 'Papel e dados', s3: 'Revisão' },
    name: 'Nome completo',
    namePlaceholder: 'Ex.: Rafael Alves',
    channels: 'Canais de acesso',
    channelsHint: '· escolha um ou mais',
    whatsApp: 'Número do WhatsApp',
    whatsAppPlaceholder: '+55 47 98888-1296',
    whatsAppHint: 'Com DDI e DDD. Ex.: +55 47 98888-1296.',
    teams: 'Conta do Microsoft Teams',
    teamsPlaceholder: "nome{'@'}empresa.onmicrosoft.com",
    email: 'E-mail para acesso ao portal',
    emailPlaceholder: "nome{'@'}empresa.com.br",
    role: 'Papel',
    units: 'Unidades',
    unitsHint: '· informe uma ou mais',
    unitsHelp: 'Os dados exibidos ficam restritos às unidades informadas.',
    summary: { name: 'Nome', channels: 'Canais', role: 'Papel', units: 'Unidades' },
    onConfirm: 'Ao confirmar',
    next: {
      whatsAppShared: 'Geramos um link de convite do WhatsApp para {name} enviar uma única mensagem e vincular o número.',
      whatsAppDedicated: 'O número {number} fica autorizado no WhatsApp dedicado da empresa.',
      teams: 'A conta {account} passa a ter acesso ao assistente no Teams.',
      portal: 'Enviamos um convite para {email}. O link expira em {days} dias.',
      portalNoSender:
        'O e-mail de convite não será enviado: a empresa ainda não configurou o remetente de e-mail. Você poderá copiar o link de convite na próxima tela.',
    },
    submit: 'Enviar convite',
    submitting: 'Enviando...',
    again: 'Convidar outra pessoa',
    finish: 'Concluir',
    doneHeadline: '{name} foi convidado como {role}.',
    doneHeadlineUnits: '{name} foi convidado como {role} · {units}.',
    donePending: 'O status fica Pendente até o primeiro acesso.',
    code: 'Código do convite',
    codeHelp: 'Válido até {date}.',
    waTitle: 'Link de convite do WhatsApp',
    waText: 'Envie este link para {name}. Ao abrir, o WhatsApp já traz a mensagem {code} pronta. {name} só precisa enviá-la uma vez para vincular o número.',
    copyLink: 'Copiar link',
    linkCopied: 'Link copiado',
    linkCopiedText: 'Cole o link em uma conversa ou e-mail.',
    emailSentTitle: 'Convite enviado por e-mail',
    emailSentText: 'Enviamos o convite de acesso ao portal para {email}.',
    emailNotSentTitle: 'O e-mail não foi enviado',
    emailNotSent: {
      tenant_sender_not_configured:
        'A empresa ainda não configurou o remetente de e-mail (Configurações › E-mail). Copie o link abaixo e envie para {email} por outro meio.',
      mail_service_unavailable: 'O serviço de e-mail está indisponível no momento. Copie o link abaixo e envie para {email} por outro meio.',
      default: 'Copie o link abaixo e envie para {email} por outro meio.',
    },
    acceptLink: 'Link para aceitar o convite',
    configureEmail: 'Configurar e-mail',
    configureWhatsApp: 'Cadastrar número do WhatsApp',
    waNoNumberTitle: 'Link do WhatsApp não gerado',
    waNoNumberText: 'A empresa ainda não tem número de WhatsApp cadastrado. Passe o código {code} para {name} e cadastre o número em Configurações › Canais para gerar o link e o QR code nos próximos convites.',
    teamsDoneTitle: 'Acesso no Teams liberado',
    teamsDoneText: 'A conta {account} já encontra o assistente no Microsoft Teams.',
    waDedicatedTitle: 'Número autorizado no WhatsApp',
    waDedicatedText: '{number} já pode conversar com o assistente pelo WhatsApp da empresa. Não é preciso enviar código.',
    welcomeSentTitle: 'Boas-vindas enviadas pelo WhatsApp',
    welcomeSentText: '{name} vai receber em {number} uma mensagem do assistente, com exemplos do que pode perguntar.',
    welcomeSentShared: '{name} vai receber em {number} uma mensagem do assistente, com exemplos do que pode perguntar. Para liberar o acesso, basta responder com o código {code}.',
    welcomeNotSentTitle: 'A mensagem de boas-vindas não foi enviada',
    welcomeNotSent: {
      not_connected: 'O número de WhatsApp que envia as mensagens não está conectado. O convite continua válido.',
      default: 'O serviço de WhatsApp não respondeu. O convite continua válido.',
    },
    errors: {
      name: 'Informe o nome da pessoa.',
      channels: 'Escolha ao menos um canal.',
      whatsApp: 'Informe o número com DDI e DDD. Ex.: +55 47 98888-1296.',
      teams: 'Informe a conta do Teams (e-mail).',
      email: 'Informe um e-mail válido.',
      role: 'Escolha um papel.',
      units: 'Informe ao menos uma unidade.',
    },
  },
  // Data connector: the values a person can be restricted to (e.g. customers), searched in the company's system.
  partitions: {
    search: 'Buscar {plural} pelo nome, CNPJ ou cidade',
    searching: 'Buscando…',
    none: 'Nada encontrado.',
    error: 'Não foi possível consultar o sistema da empresa agora.',
  },
  units: {
    add: 'Adicionar',
    placeholder: 'Ex.: unidade-norte',
    remove: 'Remover {unit}',
    suggestions: 'Unidades já usadas:',
  },
  changeRole: {
    title: 'Alterar papel de {name}',
    submit: 'Salvar alteração',
    done: 'Papel alterado',
    doneText: '{name} agora é {role}. Vale a partir da próxima consulta.',
  },
  contacts: {
    action: 'Editar contatos',
    title: 'Contatos de {name}',
    subtitle: 'Por onde a pessoa usa o assistente.',
    email: 'E-mail de acesso ao portal',
    emailHint: 'Para dar acesso pelo portal. A pessoa recebe um link para criar a senha.',
    emailLockedHint: 'É o login da pessoa no portal e não muda aqui.',
    whatsApp: 'Número do WhatsApp',
    whatsAppHint: 'Com DDI e DDD. Deixe em branco para tirar o acesso pelo WhatsApp. No modo compartilhado, um número novo precisa enviar o código de convite de novo.',
    teams: 'Conta do Microsoft Teams',
    teamsHint: 'Deixe em branco para tirar o acesso pelo Teams.',
    save: 'Salvar contatos',
    done: 'Contatos atualizados',
    doneText: 'Os contatos de {name} foram atualizados.',
    portalEmailSent: 'Os contatos de {name} foram atualizados. O link para criar a senha foi enviado para {email}.',
    portalLinkTitle: 'Acesso pelo portal liberado',
    portalLinkText: 'O e-mail não foi enviado. Copie o link abaixo e repasse a {name} para criar a senha.',
    portalLinkNone: 'O e-mail não foi enviado e o endereço do portal não está configurado para gerar o link. Fale com o suporte.',
  },
  revoke: {
    title: 'Revogar o acesso de {name}?',
    text: '{name} deixa de consultar o assistente em todos os canais imediatamente. O histórico de consultas continua na auditoria.',
    confirm: 'Revogar acesso',
    done: 'Acesso revogado',
    doneText: '{name} não pode mais consultar o assistente.',
  },
  deleteUser: {
    title: 'Excluir {name}?',
    text: '{name} sai da lista e perde o acesso em todos os canais. Se não tiver acesso a mais nada, o cadastro de login também é apagado. Não dá para desfazer; o histórico na auditoria continua.',
    confirm: 'Excluir usuário',
    done: 'Usuário excluído',
    doneText: '{name} foi removido.',
  },
  activationLink: {
    copiedTitle: 'Link de ativação de {name} copiado',
    copiedText: 'É um link novo: o enviado antes por e-mail deixa de valer. Cole na conversa com a pessoa.',
    unavailableTitle: 'Não foi possível montar o link',
    unavailableText: 'O endereço de aceite do convite não está configurado. Código do convite: {code}.',
  },
  resend: {
    done: 'Convite reenviado',
    doneText: 'Novo código: {code}.',
    doneNoEmail: 'Novo código: {code}. O e-mail não foi enviado; copie o link na lista de convites.',
    welcomeSent: 'A mensagem de boas-vindas foi enviada pelo WhatsApp.',
    title: 'Convite reenviado para {name}',
  },
  integrations: {
    title: 'Integrações',
    subtitle: 'Contas suas ligadas a outros serviços.',
    status: { connected: 'Conectado', notConnected: 'Não conectado', reconnect: 'Conecte de novo' },
    google: {
      title: 'Google Agenda',
      text: 'Leve as reuniões para a sua agenda do Google, com link do Meet e convites. Cada pessoa conecta a própria conta.',
      off: 'A integração com o Google não está ligada neste ambiente.',
      mailMissing: 'Para os relatórios de reunião saírem pelo seu Gmail (e ficarem nos seus Enviados), conecte a conta de novo, uma vez.',
      reconnectMail: 'Conectar de novo para enviar pelo Gmail',
    },
    // Microsoft To Do (19/10/2026).
    todo: {
      title: 'Microsoft To Do',
      text: 'As suas reuniões vão para a lista "AubaineOS" do seu To Do, com o horário, o cliente e o link da chamada. Vale conta pessoal da Microsoft (Outlook, Hotmail).',
      off: 'A integração com o Microsoft To Do não está ligada neste ambiente.',
      connect: 'Conectar conta Microsoft',
      connectedAs: 'Conectado como {email}',
      reconnectText: 'A Microsoft recusou o acesso ao seu To Do. Conecte a conta de novo.',
      disconnect: 'Desconectar',
      disconnected: 'Conta Microsoft desconectada. As tarefas que já estão no To Do continuam lá.',
      syncNow: 'Sincronizar agora',
      synced: 'Reuniões enviadas ao To Do.',
      syncedAt: 'Última sincronização: {when}',
      connected: 'Conta Microsoft conectada. As suas reuniões chegam ao To Do em instantes.',
      errors: {
        negado: 'A conexão com a Microsoft foi cancelada.',
        expirado: 'O link de conexão expirou. Tente de novo.',
        falhou: 'Não foi possível conectar à Microsoft. Tente de novo.',
      },
    },
    // Granola (03/11/2026).
    granola: {
      title: 'Granola',
      text: 'Cada anotação de reunião que a Granola terminar vira uma tarefa no cliente, com o resumo e a duração. Quando não achamos o cliente, a anotação espera na lista "Não vinculadas". Cada pessoa usa a própria conta.',
      keyLabel: 'Chave de API da Granola',
      keyPlaceholder: 'grn_…',
      keyHelp: 'Na Granola: Configurações › Connectors › API keys. Marque o acesso às suas anotações pessoais.',
      connect: 'Conectar',
      replaceKey: 'Trocar a chave',
      connectedWithKey: 'Conectada (chave terminada em {hint})',
      reconnectText: 'A Granola recusou a chave. Cole uma chave nova.',
      modeWebhook: 'As anotações chegam na hora, pelo aviso da Granola.',
      modePolling: 'Buscamos as anotações novas a cada 1 minuto.',
      lastNote: 'Última anotação: {when}',
      unlinked: 'Nenhuma anotação sem cliente | 1 anotação sem cliente | {n} anotações sem cliente',
      openList: 'Ver anotações',
      syncNow: 'Buscar agora',
      synced: 'Anotações conferidas.',
      disconnect: 'Desconectar',
      disconnected: 'Granola desconectada. As tarefas já criadas continuam.',
      connectedWebhook: 'Granola conectada. As anotações chegam na hora.',
      connectedPolling: 'Granola conectada. Vamos buscar as anotações a cada 1 minuto.',
    },
    // "Seu dia" (17/10/2026).
    digest: {
      title: 'Seu dia por e-mail',
      text: 'Nos dias úteis às 8h: as suas reuniões, as tarefas e atividades de hoje e o que está atrasado. Sem nada no dia, não chega e-mail.',
      on: 'Ligado',
      off: 'Desligado',
      toggle: 'Receber o resumo às 8h',
      sendNow: 'Enviar agora para mim',
      sent: 'Resumo enviado para {email}.',
      turnedOn: 'Você vai receber o resumo às 8h.',
      turnedOff: 'Resumo desligado.',
    },
  },
  settings: {
    title: 'Configurações',
    subtitle: 'Marca, canais e regras de acesso do portal {tenant}.',
    tabs: { label: 'Seções', brand: 'Marca', channels: 'Canais', erp: 'Integração com ERP', documents: 'Módulo ERP', cnpj: 'Análise de CNPJ', ai: 'IA', email: 'E-mail', address: 'Endereço', rules: 'Convites e auditoria', integrations: 'Integrações' },
    teams: 'Microsoft Teams',
    teamsDomain: 'Organização Microsoft',
    teamsDomainPlaceholder: 'suaempresa.onmicrosoft.com',
    teamsDomainHint: 'Domínio da organização no Microsoft 365. As contas do Teams convidadas precisam ser dele.',
    portal: 'Portal web',
    portalActive: 'Ativo',
    portalAddress: 'Endereço:',
    retention: 'Retenção da auditoria',
    retentionHint: 'Por quanto tempo os registros da auditoria ficam guardados. Depois disso, são apagados automaticamente.',
    months: '{count} meses',
    blockedAlerts: 'Avisar por e-mail sobre tentativas bloqueadas',
    blockedAlertsDesc: 'O dono recebe um resumo diário quando alguém tenta consultar algo fora do papel ou da unidade.',
    assistantActionsTitle: 'Ações do assistente',
    assistantActionsEnabled: 'Permitir ações pelo assistente',
    assistantActionsEnabledDesc: 'Libera para pessoas com a permissão adequada confirmar ações no ERP pelo chat web. A plataforma também precisa manter as ações habilitadas.',
    actionPlansPerHour: 'Limite de planos por pessoa por hora',
    actionPlansPerHourHint: 'Limita quantos cadastros o assistente pode propor para cada pessoa.',
    actionPlansPerHourOption: '{count} por hora',
    erp: {
      title: 'Conexão com o ERP',
      notConfigured: 'Nenhum ERP conectado',
      notConfiguredText: 'A conexão com o ERP da empresa é feita pela equipe de suporte. Enquanto isso, o assistente ainda não responde consultas.',
      status: { not_configured: 'Não conectado', connected: 'Conectado', unavailable: 'Indisponível' },
      lastCheck: 'Última verificação: {date}',
      neverChecked: 'Ainda não verificado',
      test: 'Testar conexão',
      testOk: 'Conexão com o {system} funcionando',
      testFailed: 'A conexão com o ERP falhou',
      queries: 'Consultas disponíveis no ERP',
      available: 'Disponível',
      unavailable: 'Indisponível',
      queriesHint: 'Consultas indisponíveis aparecem desabilitadas no editor de papéis.',
    },
    theme: {
      title: 'Tema do cliente',
      intro: 'Defina as cores dos temas claro e escuro e o estilo padrão dos componentes. O layout do portal deste cliente é montado a partir destas escolhas.',
      editing: 'Tema em edição',
      modes: { light: 'Claro', dark: 'Escuro' },
      export: 'Exportar',
      import: 'Importar',
      importLabel: 'Importar configuração de cores',
      restore: 'Restaurar cores padrão',
      tabs: { colors: 'Cores', css: 'CSS personalizado' },
      active: 'Ativo',
      base: 'base',
      groups: { layout: 'Layout', brand: 'Cores da marca', states: 'Estados', surfaces: 'Outras superfícies' },
      layoutHint: 'O menu lateral e o topo usam a cor "Menu e topo"; o conteúdo fica sobre o "Fundo do conteúdo", e os cards, painéis e janelas usam a cor "Cards".',
      navigationUnused: 'Hoje a barra superior usa a cor "{bar}" e o menu lateral, "{menu}".',
      useNavigation: 'Usar "Menu e topo" nos dois',
      automatic: 'Automático',
      automaticNote: 'Automático: um tom da cor de destaque',
      colors: {
        primary: 'Primária',
        'primary-darken-1': 'Primária escura',
        secondary: 'Secundária',
        'secondary-darken-1': 'Secundária escura',
        success: 'Sucesso',
        info: 'Informação',
        warning: 'Atenção',
        error: 'Erro',
        background: 'Fundo do conteúdo',
        surface: 'Cards',
        'surface-bright': 'Superfície clara',
        'surface-light': 'Superfície suave',
        'surface-variant': 'Superfície variante',
        'on-surface-variant': 'Texto na superfície variante',
        navigation: 'Menu e topo',
        'navigation-active': 'Item ativo do menu',
      },
      pick: 'Escolher cor',
      pickColor: 'Escolher cor: {name}',
      hexOf: 'Código hexadecimal: {name}',
      textOn: 'Texto calculado sobre a cor',
      invalidColors: 'Use o formato #RRGGBB nas cores destacadas.',
      variations: 'Variações',
      variationsHint: 'Gera tons mais claros e mais escuros das cores escolhidas, usados em estados como passar o mouse e selecionado.',
      variationColors: 'Cores com variações',
      lighten: 'Tons mais claros',
      darken: 'Tons mais escuros',
      defaults: 'Padrões dos componentes',
      components: {
        initial: 'Tema inicial',
        button: 'Botão',
        textField: 'Campo de texto',
        chip: 'Chip',
        appBar: 'Barra superior',
        navigationDrawer: 'Menu lateral',
      },
      fields: { theme: 'Tema', color: 'Cor', focusColor: 'Cor em foco', variant: 'Variante', rounded: 'Arredondamento' },
      initial: { light: 'Claro', dark: 'Escuro', system: 'Seguir o sistema' },
      buttonVariants: { elevated: 'Preenchido com sombra', flat: 'Preenchido', tonal: 'Tonal', outlined: 'Contorno', text: 'Texto', plain: 'Discreto' },
      roundings: { '0': 'Nenhum', sm: 'Pequeno', default: 'Padrão', lg: 'Grande', xl: 'Extra grande', pill: 'Cápsula' },
      fieldVariants: { outlined: 'Contorno', filled: 'Preenchido', underlined: 'Sublinhado', solo: 'Elevado', plain: 'Sem borda' },
      chipVariants: { tonal: 'Tonal', flat: 'Preenchido', elevated: 'Preenchido com sombra', outlined: 'Contorno', text: 'Texto' },
      css: {
        calloutTitle: 'Precisa de um ajuste que as cores não cobrem?',
        calloutText: 'Use o CSS personalizado: ele é aplicado depois das cores, no portal e nas telas de entrada.',
        calloutAction: 'Editar CSS personalizado',
        intro: 'Use para ajustes que as cores não cobrem. O CSS é aplicado depois das cores do tema: ele complementa o que foi configurado e, quando define a mesma coisa, prevalece.',
        order: 'Ordem de aplicação',
        orderColors: 'Cores do tema',
        wins: 'prevalece',
        upload: 'Enviar arquivo .css',
        uploadLabel: 'Enviar arquivo CSS',
        download: 'Baixar .css',
        remove: 'Remover',
        file: 'Arquivo: {name}',
        code: 'Código CSS',
        empty: 'Nenhum CSS personalizado. As cores do tema são usadas sem alterações.',
        lines: '{count} linha | {count} linhas',
        meta: '{lines} · {size} KB de 100 KB',
        variables: 'Variáveis das cores do tema',
        variablesHint: 'Redefina uma variável para trocar a cor em todos os lugares em que ela aparece. Clique para inserir no código.',
        insert: 'Inserir {name}',
        tooBig: 'Arquivo muito grande',
        tooBigText: 'O CSS personalizado pode ter até 100 KB.',
        loaded: 'CSS carregado',
        loadedText: 'Revise a prévia e clique em Salvar para aplicar ao portal.',
      },
      exported: 'Cores exportadas',
      exportedText: 'Arquivo {name} baixado.',
      importInvalid: 'Arquivo não reconhecido',
      importInvalidText: 'Use um arquivo .json exportado nesta tela.',
      importTitle: 'Substituir as cores atuais?',
      importText: 'As cores e os padrões dos componentes de {source} vão substituir a configuração atual. Nada é salvo até você clicar em Salvar.',
      importConfirm: 'Substituir cores',
      preview: {
        label: 'Prévia · tema {mode}',
        withCss: ' · com CSS personalizado',
        aria: 'Prévia do tema',
        nav: { orders: 'Pedidos', customers: 'Clientes', stock: 'Estoque' },
        cardTitle: 'Pedidos em aberto',
        search: 'Buscar pedido',
        chips: { open: 'Em aberto', billed: 'Faturado', late: 'Atrasado' },
        save: 'Salvar',
        alerts: { success: 'Pedido enviado ao ERP', info: 'Sincronização em andamento', warning: 'Estoque abaixo do mínimo', error: 'Falha na conexão' },
      },
      errors: {
        colors: 'Use o formato #RRGGBB em todas as cores antes de salvar.',
        css: 'Corrija o CSS personalizado antes de salvar.',
      },
    },
    displayName: 'Nome exibido',
    displayNameHint: 'Aparece no menu do portal, nos e-mails de convite e nas respostas do assistente.',
    sidebarCollapsible: 'Menu lateral recolhível',
    sidebarCollapsibleDesc: 'Cada pessoa pode recolher o menu lateral para ver só os ícones e ganhar espaço. Desmarcado, o menu fica sempre aberto.',
    pageTitle: 'Título da aba do navegador',
    pageTitleHint: 'Vem antes do nome da tela, ex.: “{example}”. Vazio, usa o nome exibido.',
    whatsApp: 'WhatsApp',
    whatsAppMode: 'Modo do WhatsApp',
    whatsAppNumber: 'Número da empresa',
    whatsAppNumberHint: 'Com DDI e DDD, só números. Ex.: 5511988887777.',
    connected: 'Conectado',
    noNumber: 'Sem número',
    inviteValidity: 'Validade do convite',
    inviteValidityHint: 'Depois desse prazo, o link do convite deixa de funcionar e é preciso reenviar.',
    days: '{count} dias',
    invitePrefix: 'Prefixo do código de convite',
    invitePrefixHint: 'De 2 a 8 letras maiúsculas ou números. Ex.: ACME gera códigos como ACME-7F3K.',
    unsaved: 'Alterações não salvas',
    saved: 'Tudo salvo',
    savedToast: 'Configurações salvas',
    savedToastText: 'As alterações já valem para o portal e para os novos convites.',
    whatsAppModeFixed: 'O tipo de número é definido pelo suporte da plataforma. Para trocar entre compartilhado e dedicado, fale com o suporte.',
    brandAi: {
      title: 'Gerar cores com IA',
      hint: 'Envie a identidade visual da marca (logo ou manual da marca): as cores dela são lidas aqui no navegador e a IA monta os temas claro e escuro. O arquivo não é enviado nem salvo; revise as cores abaixo e salve.',
      upload: 'Enviar identidade visual',
      useLogo: 'Usar o logo atual',
      formats: 'PNG, JPG, SVG ou WebP (até 5 MB) ou PDF (até 30 MB; as 5 primeiras páginas).',
      previewAlt: 'Identidade visual enviada',
      found: 'Cores encontradas',
      notes: 'Observações para a IA (opcional)',
      notesPlaceholder: 'Ex.: o azul é a cor principal; evitar vermelho nos botões.',
      generate: 'Gerar cores com IA',
      generating: 'Gerando…',
      undo: 'Desfazer',
      applied: 'Cores aplicadas no rascunho.',
      appliedTitle: 'Cores geradas',
      appliedText: 'Os temas claro e escuro foram preenchidos. Revise e salve para publicar.',
      type: 'Envie uma imagem PNG, JPG, SVG ou WebP, ou um PDF.',
      tooBig: 'A imagem pode ter até 5 MB.',
      pdfTooBig: 'O PDF pode ter até 30 MB.',
      unreadable: 'Não foi possível ler as cores desse arquivo (se for um PDF, ele pode estar protegido por senha).',
      noColors: 'A imagem não tem cores visíveis (é toda transparente?).',
      unavailable: 'A IA não está configurada neste ambiente.',
    },
    brand: {
      color: 'Cor da marca',
      colorHint: 'Usada nos botões, links e no logo das telas de entrada e do convite.',
      presets: 'Cores sugeridas',
      default: 'Padrão',
      custom: 'Outra cor (hex)',
      customPlaceholder: '#1F5BC8',
      preview: 'Prévia',
      previewButton: 'Entrar',
      previewLink: 'Esqueci minha senha',
      lightWarning: 'Essa cor é clara para texto branco. Para manter a leitura, os botões ficam pretos no tema claro e brancos no escuro; a cor continua no logo.',
      linkWarning: 'Os links ficam na cor do texto, porque essa cor tem pouco contraste com o fundo.',
      presetNames: { azul: 'Azul', verde: 'Verde', violeta: 'Violeta', terracota: 'Terracota' },
      logo: 'Logo',
      logoHint: 'PNG, JPG ou SVG de até 1 MB, de preferência com fundo transparente. Sem logo, mostramos só o nome da empresa.',
      logoDark: 'Logo para o tema escuro',
      logoDarkHint: 'Opcional. Aparece quando a pessoa usa o tema escuro; sem ele, usamos o logo normal.',
      logoUpload: 'Enviar logo',
      logoReplace: 'Trocar logo',
      logoRemove: 'Remover logo',
      logoUploaded: 'Logo atualizado',
      logoUploadedText: 'Ele já aparece no portal e nas telas de entrada.',
      logoRemoved: 'Logo removido',
      logoTooBig: 'O arquivo tem mais de 1 MB.',
      logoType: 'Use um arquivo PNG, JPG ou SVG.',
      favicon: 'Favicon',
      faviconHint: 'Ícone da aba do navegador no portal e nas telas de entrada. ICO, PNG ou SVG quadrado (32×32 ou maior), até 1 MB.',
      faviconPreview: 'Prévia da aba do navegador',
      faviconUpload: 'Enviar favicon',
      faviconReplace: 'Trocar favicon',
      faviconRemove: 'Remover favicon',
      faviconUploaded: 'Favicon atualizado',
      faviconUploadedText: 'Ele já aparece na aba do navegador. Em abas abertas antes, pode levar alguns minutos.',
      faviconRemoved: 'Favicon removido',
      faviconType: 'Use um arquivo ICO, PNG, JPG ou SVG.',
      icon: 'Ícone do menu recolhido',
      iconHint: 'Aparece no topo do menu lateral quando ele está recolhido. PNG, JPG ou SVG quadrado (64×64 ou maior), até 1 MB. Sem ele, usamos o favicon; sem favicon, as iniciais.',
      iconLight: 'Tema claro',
      iconDark: 'Tema escuro',
      iconUpload: 'Enviar ícone',
      iconReplace: 'Trocar ícone',
      iconRemove: 'Remover ícone',
      iconUploaded: 'Ícone atualizado',
      iconUploadedText: 'Ele já aparece no menu recolhido.',
      iconRemoved: 'Ícone removido',
    },
    errors: {
      brandColor: 'Use uma cor no formato #RRGGBB.',
      pageTitle: 'Use até {max} caracteres.',
      displayName: 'Informe o nome exibido.',
      whatsAppNumber: 'Informe o número com DDI e DDD, só números.',
      invitePrefix: 'Use de 2 a 8 letras maiúsculas ou números.',
      teamsDomain: 'Informe um domínio válido, como suaempresa.onmicrosoft.com.',
    },
    email: {
      title: 'Remetente de e-mail',
      intro:
        'Os convites e avisos da {tenant} saem pela conta da Resend da própria empresa. Sem essa configuração, nenhum e-mail é enviado em nome da empresa.',
      configured: 'Configurado',
      notConfigured: 'Não configurado',
      fromName: 'Nome do remetente',
      fromNamePlaceholder: 'Ex.: ACME Distribuidora',
      fromAddress: 'E-mail do remetente',
      fromAddressPlaceholder: "no-reply{'@'}suaempresa.com.br",
      fromAddressHint: 'Use um endereço de um domínio verificado na sua conta da Resend.',
      apiKey: 'Chave da API da Resend',
      apiKeyPlaceholder: 're_...',
      apiKeyHintNew: 'Crie a chave em resend.com › API Keys, com permissão de envio. Ela fica guardada criptografada e nunca é exibida de novo.',
      apiKeyHintKeep: 'Chave atual terminando em {hint}. Deixe em branco para mantê-la.',
      updatedAt: 'Atualizado em {date}',
      save: 'Salvar remetente',
      remove: 'Remover remetente',
      removeTitle: 'Remover o remetente de e-mail?',
      removeText: 'Os próximos convites da empresa serão criados sem envio de e-mail até um novo remetente ser configurado.',
      savedToast: 'Remetente salvo',
      savedToastText: 'Os próximos e-mails da empresa saem por {from}.',
      removedToast: 'Remetente removido',
      errors: {
        fromAddress: 'Informe um e-mail válido.',
        apiKey: 'Isto não parece uma chave da Resend (ela começa com "re_").',
        apiKeyRequired: 'Informe a chave da API.',
      },
    },
    address: {
      title: 'Endereço do portal',
      intro:
        'É por estes endereços que as pessoas da {tenant} entram no assistente. A tela de entrada aparece com a marca da empresa, no próprio endereço.',
      disabled: 'Os endereços próprios não estão habilitados neste ambiente. O portal continua em {url}.',
      primary: 'Principal',
      primaryHint: 'Os links dos convites e da troca de senha usam o endereço principal.',
      makePrimary: 'Tornar principal',
      open: 'Abrir',
      kind: { subdomain: 'Endereço da plataforma', custom: 'Domínio próprio' },
      status: { pending: 'Aguardando DNS', active: 'Ativo', failed: 'DNS não confere' },
      failure: {
        txt_missing: 'O registro TXT ainda não foi encontrado.',
        txt_mismatch: 'O registro TXT existe, mas o valor não confere.',
        cname_mismatch: 'O CNAME não aponta para {target}.',
        dns_error: 'Não foi possível consultar o DNS agora. Tente de novo em alguns minutos.',
      },
      lastChecked: 'Última verificação em {date}',
      addTitle: 'Usar um domínio da empresa',
      addHint: 'Use um subdomínio, como assistente.suaempresa.com.br. Um domínio sem subdomínio (suaempresa.com.br) não aceita CNAME.',
      host: 'Domínio',
      hostPlaceholder: 'assistente.suaempresa.com.br',
      add: 'Adicionar domínio',
      dnsTitle: 'Crie estes registros no DNS do domínio',
      dnsHint: 'A verificação é automática e pode levar alguns minutos depois que o DNS propagar. O certificado HTTPS é emitido sozinho quando o domínio fica ativo.',
      recordType: 'Tipo',
      recordName: 'Nome',
      recordValue: 'Valor',
      copy: 'Copiar',
      copied: 'Copiado',
      verify: 'Verificar agora',
      verifiedToast: 'Domínio ativo',
      verifiedToastText: 'O portal já responde em {host}.',
      pendingToast: 'O DNS ainda não confere',
      addedToast: 'Domínio adicionado',
      addedToastText: 'Crie os registros de DNS mostrados para ativar {host}.',
      primaryToast: 'Endereço principal alterado',
      remove: 'Remover',
      removeTitle: 'Remover o domínio?',
      removeText: 'O portal deixa de responder em {host}. Se era o endereço principal, o endereço da plataforma volta a ser.',
      removedToast: 'Domínio removido',
      errors: {
        host: 'Informe um domínio válido, como assistente.suaempresa.com.br.',
      },
    },
  },
  // Configurações › IA, the "IA" section of the role editor and the model selector of the chat (15/10/2026).
  ai: {
    title: 'Inteligência artificial',
    intro: 'Use a IA da plataforma ou conecte as contas da empresa no ChatGPT, no Grok, no Claude, no Gemini, na Groq, na OpenRouter, na Cerebras ou na Hugging Face. Com a chave da empresa, o uso é cobrado na conta dela.',
    privacy: 'As perguntas e os dados consultados nas conversas vão para o provedor do perfil escolhido. Confira se o contrato da empresa com ele permite.',
    keys: {
      title: 'Chaves de API',
      intro: 'Cada chave só é salva depois que o provedor a aceita. Ela fica protegida e nunca é mostrada de novo, só os 4 últimos caracteres.',
      configured: 'Configurada',
      refused: 'Recusada',
      notConfigured: 'Sem chave',
      endsWith: 'termina em {hint}',
      checkedAt: 'verificada em {date}',
      label: 'Chave de API',
      hint: 'Copie a chave no painel do provedor e cole aqui.',
      save: 'Salvar chave',
      test: 'Testar',
      replace: 'Trocar chave',
      remove: 'Remover',
      add: 'Adicionar chave',
      saved: 'Chave salva',
      savedText: '{provider} aceitou a chave: {count} modelos disponíveis.',
      removed: 'Chave removida',
      removeTitle: 'Remover a chave de {provider}?',
      removeText: 'Os perfis de IA que usam {provider} param de responder até uma chave nova ser cadastrada.',
      testOk: 'A chave funciona: {count} modelos disponíveis.',
      testFailed: 'A chave não funcionou: {error}',
    },
    profiles: {
      title: 'Perfis de IA',
      intro: 'Um perfil é um nome para um provedor e um modelo, como "Padrão" ou "Avançado". Os papéis dizem quem usa cada perfil.',
      platform: 'Plataforma',
      platformDesc: 'A IA da plataforma, incluída no serviço.',
      new: 'Novo perfil',
      edit: 'Editar perfil',
      editAction: 'Editar',
      name: 'Nome',
      namePlaceholder: 'Ex.: Avançado',
      provider: 'Provedor',
      model: 'Modelo',
      modelHint: 'Os modelos vêm da lista do provedor, pela chave da empresa.',
      modelPlaceholder: 'Digite para buscar o modelo',
      modelLoading: 'Carregando os modelos…',
      modelEmpty: 'Nenhum modelo com esse nome.',
      modelMore: '+ {count} modelos. Digite mais para filtrar.',
      noKey: 'Cadastre a chave de {provider} para escolher um modelo.',
      enabled: 'Perfil ativo',
      disabled: 'Desativado',
      unavailable: 'Indisponível',
      saved: 'Perfil salvo',
      removed: 'Perfil removido',
      removeTitle: 'Remover o perfil {name}?',
      removeText: 'Os papéis e os canais que usam este perfil voltam ao padrão.',
      empty: 'Nenhum perfil da empresa. Sem eles, todos usam a IA da plataforma.',
    },
    defaults: {
      title: 'Perfil padrão de cada canal',
      intro: 'Vale para quem não tem um perfil definido no papel.',
      chat: 'Chat do portal',
      whatsApp: 'WhatsApp',
      monitoring: 'Resumo dos alertas do Monitoramento',
      platform: 'IA da plataforma',
      saved: 'Padrões salvos',
    },
    role: {
      group: 'Inteligência artificial',
      hint: 'Perfis de IA que quem tem este papel pode usar no chat. Com mais de um, a pessoa escolhe; sem nenhum, usa o padrão da empresa.',
      ownerLocked: 'O Dono pode usar todos os perfis.',
      default: 'Começa com',
      defaultInstitution: 'Padrão da empresa',
      none: 'Nenhum perfil de IA cadastrado. Crie em Configurações › IA.',
      changes: 'IA: {items}',
      changesNone: 'padrão da empresa',
    },
    chat: {
      label: 'Modelo de IA',
      button: 'Modelo de IA: {name}',
      change: 'Trocar o modelo de IA',
      default: 'Padrão',
      unavailableHint: 'Indisponível agora.',
    },
  },
}
